import { Sparkles, Compass, RefreshCw, Target, TrendingUp, ArrowRight } from "lucide-react";
import { NavLink } from "@/components/NavLink";

const phases = [
  { icon: Sparkles, phase: "Ontdekken", year: "Onderbouw", text: "Interesses en talenten verkennen.", result: "RIASEC & interesses" },
  { icon: Compass, phase: "Oriënteren", year: "Brede oriëntatie", text: "Beroepen en richtingen onderzoeken.", result: "Profielinzichten" },
  { icon: RefreshCw, phase: "Verdiepen", year: "Ervaren & reflecteren", text: "Activiteiten doen en erop reflecteren.", result: "Reflecties & gesprekken" },
  { icon: Target, phase: "Kiezen", year: "Keuzefase", text: "Profiel, vakken en opleidingen afwegen.", result: "Onderbouwde keuze" },
  { icon: TrendingUp, phase: "Voorbereiden", year: "Examenfase", text: "Open dagen, inschrijven en doorstroom.", result: "Compleet LOB-dossier" },
];

const LeerlijnSection = () => {
  return (
    <section className="relative py-28 lg:py-36 animate-on-scroll overflow-hidden">
      <div className="pointer-events-none absolute top-1/3 -left-24 w-96 h-96 rounded-full bg-accent/60 blur-3xl" />

      <div className="container mx-auto max-w-4xl px-4 sm:px-6 relative text-center">
        <span className="inline-block text-[11px] font-bold tracking-[0.2em] uppercase text-primary mb-6 px-3 py-1 bg-accent rounded-full">
          De doorlopende LOB-leerlijn
        </span>

        <h2 className="text-3xl sm:text-4xl lg:text-[3.1rem] font-extrabold text-secondary leading-[1.25] mb-8">
          Een goede studiekeuze begint niet in{" "}
          <span className="bg-gradient-to-r from-primary to-[hsl(212_90%_55%)] bg-clip-text text-transparent">
            het examenjaar.
          </span>
        </h2>

        <p className="text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
          Een goede keuze ontstaat niet op het moment dat een leerling móet
          kiezen. Die ontstaat doordat een leerling zichzelf jarenlang leert
          kennen.
        </p>
      </div>

      {/* prominente leerlijn */}
      <div className="container mx-auto max-w-6xl px-4 sm:px-6 relative mt-20">
        <div className="relative">
          <div className="hidden lg:block absolute top-8 left-[10%] right-[10%] h-1.5 rounded-full bg-gradient-to-r from-primary via-primary/60 to-warm/60" />
          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-4">
            {phases.map((p, i) => (
              <div key={p.phase} className="relative flex flex-col items-center text-center">
                <div className="relative z-10 w-16 h-16 rounded-2xl bg-primary text-primary-foreground flex items-center justify-center shadow-medium mb-5">
                  <p.icon className="w-7 h-7" />
                  <span className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-card border border-border text-xs font-extrabold text-primary flex items-center justify-center shadow-soft">
                    {i + 1}
                  </span>
                </div>
                <span className="text-[11px] font-bold tracking-wider uppercase text-primary mb-1">
                  {p.year}
                </span>
                <h3 className="text-lg font-extrabold text-secondary mb-2">{p.phase}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed max-w-[200px]">
                  {p.text}
                </p>
                <span className="mt-3 inline-flex rounded-full bg-accent px-3 py-1 text-xs font-bold text-primary">
                  {p.result}
                </span>
              </div>
            ))}
          </div>
        </div>

        <p className="mt-12 text-center text-sm text-muted-foreground">
          De invulling per fase hangt af van leerjaar, niveau en de inrichting door de school.
        </p>

        <div className="mt-8 text-center">
          <NavLink
            to="/lob-leerlijn"
            className="group inline-flex items-center gap-2 text-primary font-bold hover:gap-3 transition-all"
          >
            Ontdek de volledige leerlijn, van leerjaar 1 tot de keuze
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
          </NavLink>
        </div>
      </div>
    </section>
  );
};

export default LeerlijnSection;
